<div class="loader" *ngIf="loading$ | async">
    <div class="spinner"></div>
  </div>
  